import '../styles/LandingPage/Ticker.css';

const tickerPairs = [
  { bold: 'IFRS 17',          text: 'Implementation' },
  { bold: 'Economic Capital', text: 'Modelling' },
  { bold: 'Mortality & Morbidity', text: 'Studies' },
  { bold: 'Climate-Linked',   text: 'Actuarial Modelling' },
  { bold: 'ORSA',             text: 'Frameworks' },
  { bold: 'ALM',              text: 'Techniques' },
  { bold: 'Parametric',       text: 'Insurance' },
  { bold: 'Embedded Value',   text: 'Analysis' },
  { bold: 'Stress Testing',   text: 'Frameworks' },
];

// Duplicate for seamless infinite loop
const doubled = [...tickerPairs, ...tickerPairs];

export default function Ticker() {
  return (
    <div className="ticker-wrap">
      <div className="ticker-track">
        {doubled.map((item, i) => (
          <div className="orbital-item" key={i} style={{ '--i': i }}>
            <div className="orbital-ring" />
            <div className="orbital-text">
              <b>{item.bold}</b>
              <span className="sub">{item.text}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}